import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchStateGuideAction } from 'wanderu-ducks-seo';
import Widget from 'wanderu-widget';

import { generateLocaleAwareGuideId } from '../../utils';
import PlaceGuideContainer from '../PlaceGuide/PlaceGuide';

class StateGuideContainer extends React.Component {
    static async serverFetchData(opts) {
        const {
            dispatch,
            params,
        } = opts;

        const {
            country,
            state,
            locale,
            mode,
        } = params;

        const stateGuideId = generateLocaleAwareGuideId(params);

        await Promise.all([
            dispatch(
                fetchStateGuideAction.fetchStateGuide(stateGuideId, country, state, mode, locale),
            ),
            Widget.serverFetchData(opts),
        ]);

        await PlaceGuideContainer.serverFetchData({ ...opts, placeId: stateGuideId });
    }

    async componentDidMount() {
        const {
            match,
            isLoaded,
            stateGuideId,
            fetchStateGuide,
        } = this.props;

        if (!isLoaded) {
            const {
                country,
                state,
                mode,
                locale,
            } = match.params;

            fetchStateGuide(stateGuideId, country, state, mode, locale);
        }
    }

    async componentDidUpdate(prevProps) {
        const {
            match,
            stateGuideId,
        } = this.props;
        const {
            stateGuideId: previousStateGuideId,
        } = prevProps;

        if (stateGuideId !== previousStateGuideId) {
            const queryParams = match.params;

            this.props.fetchStateGuide(
                stateGuideId,
                queryParams.country,
                queryParams.state,
                queryParams.mode,
                queryParams.locale,
            );
        }
    }

    render() {
        return (
            <PlaceGuideContainer
                {...this.props}
                placeGuideId={this.props.stateGuideId}
                popularRoutesData
                showBreadcrumbs
                showCheapestTicket
                showInfoSection
                showInterlinkSection
            />
        );
    }
}

StateGuideContainer.propTypes = {
    fetchStateGuide: PropTypes.func.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            country: PropTypes.string.isRequired,
            locale: PropTypes.string.isRequired,
            mode: PropTypes.string.isRequired,
            state: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    stateGuideId: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
    const stateGuideId = generateLocaleAwareGuideId(ownProps.match.params);

    return {
        error: fetchStateGuideAction.selectError(state, stateGuideId),
        isFetching: fetchStateGuideAction.selectWorking(state, stateGuideId),
        isLoaded: fetchStateGuideAction.selectSuccess(state, stateGuideId),
        notFound: fetchStateGuideAction.selectNotFound(state, stateGuideId),
        stateGuideId,
    };
}

const mapDispatchToProps = {
    fetchStateGuide: fetchStateGuideAction.fetchStateGuide,
};

export {
    StateGuideContainer,
    mapStateToProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(StateGuideContainer);
